<ng-container *ngIf="getNumberOfPages() > 1">
  <nav [attr.aria-label]="ariaLabel">
    <ul class="pagination">
    <li class="page-item">
    <button
      app-button
      appTooltip="Previous Page"
      [purpose]="_buttonPurpose.Icon"
      class="page-link pager-left"
      [attr.aria-disabled]="previousButtonDisabled()"
      [attr.aria-label]="'Go to previous page'"
      (click)="previousPage()"
      [tabindex]="previousButtonDisabled() ? -1 : 0"
    >
      <i class="dpg-icon dpg-icon-dropdown-arrow-left"> </i>
    </button>
    </li>

      <ng-container *ngFor="let page of getStartPages()">
        <li class="page-item">
          <ng-container *ngTemplateOutlet="button; context: { $implicit: page }"></ng-container>
        </li>
      </ng-container>

      <li class="page-item ellipsis-item disabled" *ngIf="showFirstEllipsis">
        <span>
          &#x22ef;
        </span>
      </li>

      <ng-container *ngFor="let page of getMiddlePages()">
        <li class="page-item">
          <ng-container *ngTemplateOutlet="button; context: { $implicit: page }"></ng-container>
        </li>
      </ng-container>

      <li class="page-item ellipsis-item disabled" *ngIf="showLastEllipsis">
        <span>
          &#x22ef;
        </span>
      </li>

      <ng-container *ngFor="let page of getEndPages()">
        <li class="page-item">
          <ng-container *ngTemplateOutlet="button; context: { $implicit: page }"></ng-container>
        </li>
      </ng-container>

      <li class="page-item" [class.disabled]="nextButtonDisabled()">
    <button
      app-button
      appTooltip="Next Page"
      [purpose]="_buttonPurpose.Icon"
      class="page-link pager-right"
      [attr.aria-disabled]="nextButtonDisabled()"
      [attr.aria-label]="'Go to next page'"
      (click)="nextPage()"
      [tabindex]="nextButtonDisabled() ? -1 : 0"
    >
          <i class="dpg-icon dpg-icon-dropdown-arrow-right" aria-hidden="true"></i>
        </button>
      </li>
    </ul>
  </nav>
</ng-container>

<span class="small pt-2 pt-sm-0 ml-2" [ngStyle]="{ 'word-spacing': 'normal' }">
  <ng-container
    [ngTemplateOutlet]="pagerMessage || defaultMessage"
    [ngTemplateOutletContext]="{ $implicit: getPageItems() }"
  ></ng-container>
</span>

<ng-template #button let-page>
  <button
    class="btn btn-sm"
    [class.btn-tertiary]="pageIndex !== page"
    [class.btn-primary]="pageIndex === page"
    [attr.aria-current]="pageIndex === page"
    [disabled]="disabled"
    (click)="goToPage(page)"
  >
    <span class="sr-only">{{ 'ngx-shared-page' | translate | async }}</span>
    {{ page + 1 }}
  </button>
</ng-template>

<ng-template #defaultMessage let-pageItems>
  <span *ngIf="pageItems.count === 0" i18n></span>
  <span *ngIf="pageItems.count === 1" i18n>
    {{ pageItems.first }} {{ 'ngx-shared-of' | translate | async }} {{ pageItems.total }}
  </span>
  <span *ngIf="pageItems.count > 1" i18n>
    {{ pageItems.first }}<span class="sr-only">{{ 'ngx-shared-to' | translate | async }}</span
    ><span aria-hidden="true">&ndash;</span>{{ pageItems.last }} {{ 'ngx-shared-of' | translate | async }}
    {{ pageItems.total }}
  </span>
</ng-template>
